module.exports = __webpack_public_path__ + "static/img/nukaka_ka.15e3da5.jpg";